export class Nota {
    constructor(
        public _id: String,
        public estudiante:String,
        public materia:String,
        public periodo:String,
        public insumo1:String,
        public insumo2:String,
        public insumo3:String,
        public insumo4:String,
        public insumo5:String,
        public insumo6:String,
        public insumo7:String,
        public insumo8:String,
        public ochenta_p1:String,
        public examen1:String,
        public veinte_p1:String,
        public prointegrador1:String,
        public veintepi_p1:String,
        public promedio1:String,
        public ponderacion1:String,
        public insumo11:String,
        public insumo22:String,
        public insumo33:String,
        public insumo44:String,
        public insumo55:String,
        public insumo66:String,
        public insumo77:String,
        public insumo88:String,
        public ochenta_p2:String,
        public examen2:String,
        public veinte_p2:String,
        public prointegrador2:String,
        public veintepi_p2:String,
        public promedio2:String,
        public ponderacion2:String,
        public prointegradorf:String,
        public ponderacionpif:String,
        public examenSupletorio:String,
        public pt:String,
    ) { }
}



